const publicUrl = process.env.PUBLIC_URL || "";
// URL absoluta embutida nas assinaturas geradas (assetMode="production").
// Assinaturas distribuidas antes de 2026-07-25 apontam para
// https://outlookcapi.com.br/assinatura e continuam servidas de la — aqueles
// arquivos estao congelados no servidor antigo e nao podem ser removidos.
const productionPublicUrl = "https://assinatura.outpromo.com.br";
const staticImageBasePath = "/static/imgs";
const staticMediaBasePath = "/static/media";

const normalizeAssetPath = (path: string) => (path.startsWith("/") ? path : `/${path}`);

export const assetUrl = (path: string) => `${publicUrl}${normalizeAssetPath(path)}`;
export const imageAssetUrl = (path: string) =>
  assetUrl(`${staticImageBasePath}${normalizeAssetPath(path)}`);
export const mediaAssetUrl = (path: string) =>
  assetUrl(`${staticMediaBasePath}${normalizeAssetPath(path)}`);

export const productionAssetUrl = (path: string) =>
  `${productionPublicUrl}${normalizeAssetPath(path)}`;
export const productionImageAssetUrl = (path: string) =>
  productionAssetUrl(`${staticImageBasePath}${normalizeAssetPath(path)}`);
export const productionMediaAssetUrl = (path: string) =>
  productionAssetUrl(`${staticMediaBasePath}${normalizeAssetPath(path)}`);
